import axios from "axios";

const login = (userData, callback, errorCallback) => {
    const config ={
        url: "/api/auth/login",
        method: 'post',
        data: userData
    }

    axios.request(config)
        .then(response => callback(response.data))
        .catch(error => errorCallback(error))
}

const me = (callback, errorCallback) => {
    const config = {
        method: 'GET',
        url: '/api/auth/me',
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
        }
    };
    axios.request(config).then(response => {callback(response.data)}).catch(error => errorCallback(error));
}

const LoginActions = {login, me};

export default LoginActions;